import { render, staticRenderFns } from "./TrackingRecordUpdate.vue?vue&type=template&id=4b4d4e08&scoped=true"
import script from "./TrackingRecordUpdate.vue?vue&type=script&lang=js"
export * from "./TrackingRecordUpdate.vue?vue&type=script&lang=js"
import style0 from "./TrackingRecordUpdate.vue?vue&type=style&index=0&id=4b4d4e08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4d4e08",
  null
  
)

export default component.exports